import AnonymousAgent from '../api/AnonymousAgent'

class AnonymousReportService {
  getLocations(term: string) {
    return AnonymousAgent.Address.getLocations(term)
  }

}

export default new AnonymousReportService()
